import { render, staticRenderFns } from "./ApprovalMonthlyForm.vue?vue&type=template&id=9022c3f0&scoped=true&"
import script from "./ApprovalMonthlyForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalMonthlyForm.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=9022c3f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9022c3f0",
  null
  
)

export default component.exports